<template>
  <header class="main">
    <header-logo></header-logo>
    <div class="right" v-if="!disabled">
      <router-link class="button" to="/download">Download</router-link>
      <template v-if="user">
        <header-user-plus-menu></header-user-plus-menu>
        <router-link class="button" to="/artworks">
          <img class="center" height="24" src="/img/collection-v3@2x.png" width="24">
        </router-link>
        <header-user-account-menu :user="user"></header-user-account-menu>
        <header-user-menu :user="user"></header-user-menu>
      </template>
      <router-link v-else class="button" to="/auth">Login</router-link>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import HeaderLogo from './elements/Header/HeaderLogo'
import HeaderUserPlusMenu from './elements/Header/HeaderUserPlusMenu'
import HeaderUserAccountMenu from './elements/Header/HeaderUserAccountMenu'
import HeaderUserMenu from './elements/Header/HeaderUserMenu'

export default {
  components: { HeaderLogo, HeaderUserPlusMenu, HeaderUserAccountMenu, HeaderUserMenu },

  computed: {
    ...mapState(['authLoading', 'user', 'userAccount']),

    disabled () {
      return ['player-client', 'auth'].includes(this.$route.name) || this.authLoading
    }
  }
}
</script>
